import { ContactAccountDto } from './contact-account.dto';

export class CreateOrderDto {
  currencydescription: string;
  currencyId: number;
  finalityId: number;
  observation: string;
  receiver: Receiver;
  amount: string;
  corporateAccountId?: number;
  individualAccountId?: number;
}

export class CreateOrderInboundDto {
  id?: number;
  currencyDescription: string;
  nameSender: string;
  countrySenderId: number;
  amount: string;
  emailSender: string;
  favorite?: boolean;
  sendEmail?: boolean;
}

export class Receiver {
  name: string;
  countryId: number;
  receiveraccount: ContactAccountDto;
  intermediaryaccount: ContactAccountDto;
  favorite: boolean;
}

export class Account {
  countryId: number;
  city?: string;
  name: string;
  swift: string;
  number: string;
  aba: string;
  iban: string;
}
